// Recently Viewed Products - Simple Working Version
(function() {
    const STORAGE_KEY = 'recently_viewed_products';
    const MAX_PRODUCTS = 20;
    
    // Get product handle from URL
    function getProductHandle() {
        const path = window.location.pathname;
        const match = path.match(/\/products\/([^\/?#]+)/);
        return match ? match[1] : null;
    }
    
    // Add product to recently viewed
    function addRecentlyViewedProduct(handle) {
        if (!handle) return;
        
        let recentlyViewed = [];
        try {
            const stored = localStorage.getItem(STORAGE_KEY);
            recentlyViewed = stored ? JSON.parse(stored) : [];
        } catch (e) {
            console.warn('Error reading recently viewed products:', e);
        }
        
        // Remove if already exists
        const index = recentlyViewed.indexOf(handle);
        if (index > -1) {
            recentlyViewed.splice(index, 1);
        }
        
        // Add to beginning
        recentlyViewed.unshift(handle);
        
        // Limit to max items
        if (recentlyViewed.length > MAX_PRODUCTS) {
            recentlyViewed = recentlyViewed.slice(0, MAX_PRODUCTS);
        }
        
        localStorage.setItem(STORAGE_KEY, JSON.stringify(recentlyViewed));
        console.log('Added to recently viewed:', handle);
        console.log('Current recently viewed:', recentlyViewed);
        
        // Dispatch event for other components
        window.dispatchEvent(new CustomEvent('recentlyViewedProductAdded', {
            detail: { handle }
        }));
    }
    
    // Track product page views
    function trackProductView() {
        const handle = getProductHandle();
        if (handle) {
            console.log('Found product handle:', handle);
            addRecentlyViewedProduct(handle);
        } else {
            console.log('No product handle found');
        }
    }
    
    // Track product clicks
    function trackProductClicks() {
        document.addEventListener('click', function(event) {
            const productLink = event.target.closest('a[href*="/products/"]');
            if (productLink) {
                const href = productLink.getAttribute('href');
                const match = href.match(/\/products\/([^\/?#]+)/);
                if (match) {
                    const handle = match[1];
                    console.log('Clicked product:', handle);
                    // Add with slight delay to ensure navigation
                    setTimeout(() => addRecentlyViewedProduct(handle), 100);
                }
            }
        });
    }
    
    // Initialize tracking
    console.log('Initializing recently viewed tracking...');
    
    if (window.location.pathname.includes('/products/')) {
        trackProductView();
    }
    trackProductClicks();
    
    // Global functions for testing
    window.addRecentlyViewedProduct = addRecentlyViewedProduct;
    window.getRecentlyViewedProducts = function() {
        try {
            const stored = localStorage.getItem(STORAGE_KEY);
            return stored ? JSON.parse(stored) : [];
        } catch (e) {
            return [];
        }
    };
    window.clearRecentlyViewed = function() {
        localStorage.removeItem(STORAGE_KEY);
        console.log('Cleared recently viewed products');
    };
    
    // Test function - add some demo products
    window.testRecentlyViewed = function() {
        console.log('Adding test products...');
        addRecentlyViewedProduct('test-product-1');
        addRecentlyViewedProduct('test-product-2');
        addRecentlyViewedProduct('test-product-3');
    };
    
    console.log('Recently viewed tracking initialized');
})();

